/* eslint-disable camelcase */
import { Serializable } from '@core/models';
import { ServiceRecommendation } from './serviceRecommendation';

export class RecommendationByDemand extends Serializable {
  constructor(code_name, services) {
    super();
    this.code_name = code_name;
    this.services = services || [];
  }

  static toInstance(props = {}) {
    const services = ServiceRecommendation.toInstanceList(props.services);
    return new RecommendationByDemand(props.code_name, services);
  }

  serialize() {
    return {
      code_name: this.code_name,
      services: this.services.map((service) => service.serialize()),
    };
  }

  hasChange() {
    return this.services.some((s) => s.hasChange());
  }

  getVisibleProductsLabel() {
    const visibleProductsRange = this.services.map((service) => service.getVisibleProductsLength());
    const removedDuplicates = new Set(visibleProductsRange);
    return [...removedDuplicates].join(' | ');
  }

  getChanges() {
    return this.services.flatMap((service) => service.getChanges(this.code_name));
  }
}
